import { render, staticRenderFns } from "./TrainForm.vue?vue&type=template&id=3807ba36&scoped=true"
import script from "./TrainForm.vue?vue&type=script&lang=js"
export * from "./TrainForm.vue?vue&type=script&lang=js"
import style0 from "./TrainForm.vue?vue&type=style&index=0&id=3807ba36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3807ba36",
  null
  
)

export default component.exports